<h2 class="text-center">Add Role Functions</h2>
<!--<prettyjson [obj]='roleForm.value'></prettyjson>-->
<form [formGroup]="roleForm" (ngSubmit)="addRole()">
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-12">
      <mat-label>Role</mat-label>
      <input matInput formControlName="roleName" readonly/>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12">
      <mat-label>Function Name</mat-label>
      <input matInput formControlName="functionName"/>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12">
      <mat-label>Group Name</mat-label>
      <input matInput formControlName="group"/>
    </mat-form-field>
  </div>
  <div class="justify-content-center d-flex gap-2">

    <button mat-raised-button color="warn" type="button" (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="accent" type="button" (click)="addDefaultPermissions()">Default Permissions</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="roleForm.invalid">Update</button>
  </div>
</form>
